import { render } from "./ShopkeeperEditModal.vue?vue&type=template&id=11ab2dc8"
import script from "./ShopkeeperEditModal.vue?vue&type=script&lang=js"
export * from "./ShopkeeperEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__